import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Message} from 'semantic-ui-react';

class ClaimMessage extends Component {
  getMessageColor() {
    const {error, success} = this.props;

    if (error) {
      return 'red';
    }

    if (success) {
      return 'green';
    }

    return null;
  }

  render() {
    const {error, success} = this.props;
    
    if (!error && !success) {
      return null;
    }

    return (
      <Message color={this.getMessageColor()}>
        {error || success}
      </Message>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'error': state.returnClaim.error,
    'success': state.returnClaim.success,
  };
};

export default connect(mapStateToProps)(ClaimMessage);
